export default __webpack_public_path__ + "media/images/home/slide_2025-2026_newtyear_lg-4502f9c553b01dd83ef7097fbc066d12.png";